import useMessage from 'App/hooks/useMessage'
import useMutate from 'apollo-hooks/lib/useMutate'
import gql from 'graphql-tag'
import {inboxQueries} from '../queries'

export function useCreateConversation({vehicleId, history}) {
  const mutate = useMutate()
  const showMessage = useMessage()

  const createConversation = async () => {
    try {
      const {conversation} = await mutate({
        mutation: gql`
          mutation createConversation($vehicleId: ID) {
            conversation: createConversation(vehicleId: $vehicleId) {
              _id
            }
          }
        `,

        variables: {vehicleId},
        refetchQueries: inboxQueries
      })

      history.push(`/inbox/conversations/${conversation._id}`)
    } catch (error) {
      showMessage(error)
    }
  }

  return {createConversation}
}
